module.exports = __webpack_public_path__ + "img/boost-profile-bg.4840b877.png";